<div class="rb-wrap">
  <h3 class="rb-heading">Try It Yourself</h3>

  <div class="readability-preview">
    <div class="rb-head">
      <!-- The swatch IS the colour picker: click it to choose a colour. -->
      <input class="rb-swatch"
             type="color"
             [value]="swatch"
             (input)="onPicker($any($event.target).value)"
             aria-label="Pick a color">
      <div class="rb-input-wrap">
        <label class="rb-label" for="rb-hex">Pick a Color</label>
        <input id="rb-hex"
               class="rb-text"
               type="text"
               autocomplete="off"
               spellcheck="false"
               maxlength="7"
               inputmode="latin"
               [value]="text"
               (input)="onText($any($event.target).value)"
               (keydown)="onKey($event)"
               aria-label="Hex color code">
      </div>
    </div>

    <div class="rb-rows">
      <div class="rb-row" *ngFor="let row of rows">
        <span class="rb-preview" [style.background]="row.bgColor">
          <span [style.color]="row.textColor">Aa</span>
        </span>
        <span class="rb-info">
          <span class="rb-row-label">{{ row.label }}</span>
          <span class="rb-scores">
            <span class="rb-score" [attr.data-level]="dotLevel(row)">
              WCAG {{ row.ratio }}:1 · {{ row.normal }}
            </span>
            <span class="rb-score rb-apca">APCA Lc {{ row.apca }} · {{ row.apcaLevel }}</span>
          </span>
        </span>
      </div>
    </div>
  </div>
</div>
